export default __webpack_public_path__ + "assets/35eae9b0263c3370ae3705b329108071.png";